var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.999 8.5H17.999C17.999 5.663 15.244 4.369 12.999 4.071V2H10.999V4.071C8.75402 4.369 5.99902 5.663 5.99902 8.5C5.99902 11.206 8.66502 12.613 10.999 12.93V17.9C9.55102 17.649 7.99902 16.876 7.99902 15.5H5.99902C5.99902 18.089 8.42402 19.619 10.999 19.936V22H12.999V19.93C15.244 19.632 17.999 18.337 17.999 15.5C17.999 12.663 15.244 11.369 12.999 11.071V6.1C14.329 6.339 15.999 7.041 15.999 8.5ZM7.99902 8.5C7.99902 7.041 9.66902 6.339 10.999 6.1V10.899C9.62802 10.646 7.99902 9.897 7.99902 8.5ZM15.999 15.5C15.999 16.959 14.329 17.661 12.999 17.9V13.1C14.329 13.339 15.999 14.041 15.999 15.5Z",
    fill: "#1C1D1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/Icons.71c5f7eeb2d40c31c22777ec49755bb6.svg";
export { ForwardRef as ReactComponent };